import React from "react";
import { Box, Button, Grid, Skeleton, Typography } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ComunityRadaria from "../../../../../assets/images/ComunidadDeRadaria-Aux.webp";

const InfoRunningClub = ({
  runningClub,
  totalMembers,
  setShowModalAddImage,
  galleryList,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 5 }}>
      <Box size={5}>
        <Box
          sx={{
            backgroundColor: "rgba(212, 216, 216, 0.32)",
            padding: 3,
            maxWidth: 350,
            borderRadius: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Box sx={{ borderRadius: 5, overflow: "hidden", maxWidth: 250 }}>
            <img
              src={runningClub?.urlImg ?? ComunityRadaria}
              width={200}
              alt="imagen del club."
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#e7ef7d", height: 40 }}
              onClick={() => setShowModalAddImage(true)}
              startIcon={<AddPhotoAlternateIcon />}
            >
              Agregar imagen
            </Button>
            <Typography sx={{ textAlign: "center" }}>
              {runningClub?.description ??
                "Descripción de la club de corredores."}
            </Typography>
            <Typography>{totalMembers ?? 0} miembros</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        size={6}
        sx={{
          backgroundColor: "rgba(212, 216, 216, 0.32)",
          padding: 2,
          borderRadius: 5,
          width: "100%",
        }}
      >
        <Box
          sx={{
            height: "500px",
            width: "100%",
            overflowY: "auto",
            borderRadius: "4px",
          }}
        >
          <Grid container spacing={2}>
            {/* Estado de carga */}
            {!galleryList ? (
              // Muestra 8 skeletons mientras carga
              Array.from(new Array(4)).map((_, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={`skeleton-${index}`}
                >
                  <Box
                    sx={{
                      bgcolor: "#121212",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Skeleton
                      sx={{ bgcolor: "grey.900" }}
                      variant="rectangular"
                      width="100%"
                      height={200}
                    />
                  </Box>
                </Grid>
              ))
            ) : /* Cuando ya cargó pero no hay imágenes */
            galleryList && galleryList.length === 0 ? (
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" p={4}>
                  <Typography variant="body1" color="textSecondary">
                    No hay imágenes disponibles
                  </Typography>
                </Box>
              </Grid>
            ) : (
              /* Cuando hay imágenes */
              galleryList.map((image, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 1,
                    }}
                  >
                    <img
                      src={image?.url || ComunityRadaria}
                      alt="Imagen de la club de corredores."
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoRunningClub;
